import { hasCapability, type User } from "../base";

export const serviceArea = {
  update: (user: User) => hasCapability(user, "serviceArea.update"),
  delete: (user: User) => hasCapability(user, "serviceArea.delete"),
  read: (user: User) => hasCapability(user, "serviceArea.read"),
};
